import common from "./common";

export default class Mediator
{
    constructor()
    {
        this.pcApp = null;
        this.application = null;
        this.boardArrays = null;
        this.portrait = false;
    }

    init()
    {

    }

    startScreenFlow()
    {
        this.application.startScreenFlow();
    }

    beginApp()
    {
        this.application.beginApp();
    }

    boardsFlipped()
    {
        console.log('boardsFlipped??');
        this.application.onBoardsFlipped();
    }

    sendBoardArrays(ba)
    {
        this.boardArrays = ba;
    }

    redirectToBasicMode()
    {
        window.location = "basic.html?language=" + common.country;
    }
}